const dashboard = {
  dashboard: {
    title: 'Dashboard',
    switchToClassic: 'In die klassische Ansicht wechseln',
    comingSoon: 'Demnächst',
    companyScoreCard: 'Scorecard Unternehmensleistung',
    enphaseSince: 'Enphase-Installationen seit',
    sitesCommissioned: 'Anlagen in Betrieb genommen',
    microinverters: 'Mikro-Wechselrichter installiert',
    batteriesInstalled: 'Batterien installiert',
    nps: 'Net Promoter Score (Kundenzufriedenheit)',
    ensembleCertified: 'Befugte Speicherinstallationsfirma',
    einLearn: 'Erfahren Sie mehr über das EIN',
    yes: 'Ja',
    no: 'Nein',
    lastMonth: {
      one: 'im letzten Monat',
      other: 'in den letzten %{count} Monaten'
    },
    congratulations: 'Herzlichen Glückwunsch!',
    acceptInvitation: 'Einladung annehmen',
    einInvitation: 'Sie wurden eingeladen, sich dem Enphase Installer Network anzuschließen.',
    leadsInvitation: 'Sie wurden eingeladen, sich dem Enphase Leads-Programm anzuschließen.',
    announcements: 'Ankündigungen',
    systems: 'Systeme',
    all: 'Alle',
    alerts: 'Benachrichtigungen',
    activations: 'Aktivierungen',
    leads: 'Leads',
    search: 'Suche',
    noResult: 'Keine Ergebnisse gefunden',
    viewActivations: 'Alle Aktivierungen anzeigen',
    viewLeads: 'Alle Leads anzeigen',
    viewSystems: 'Alle Systeme anzeigen',
    addNewSystems: 'Neues System hinzufügen',
    total: 'Gesamt',
    activatedSites: 'Aktivierte Anlagen',
    nameId: 'Name / ID',
    status: 'Status',
    city: 'Stadt',
    state: 'Bundesland',
    //TODO - new translation added
    leadSource: 'Lead Source',
    createNewLead: 'Create New Lead',
    //TODO ends
    notAvailable: 'Nicht verfügbar',
    quickAccess: 'Schneller Zugang',
    contactUs: 'Kontaktieren Sie uns',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Service-Verknüpfungen',
    newsletter: 'Newsletter für Installateure',
    service: 'Service-Manager',
    enphaseleads: 'Enphase Leads-Programm',
    enphaseCommunity: 'Enphase-Community',
    enphaseStore: 'Enphase-Store',
    systemConfigurator: 'Systemkonfiguration',
    criticalUpdates: 'Wichtige Updates',
    documentation: 'Dokumentation',
    brandLibrary: 'Brand Library',
    training: 'Schulung und Zertifizierung',
    newsBoard: 'Nachrichtenbrett',
    noContentAvailable: 'Keine Inhalte verfügbar',
    viewEinDashboard: 'EIN Dashboard anzeigen',
    enterComments: 'Voer uw opmerkingen in',
    maxAllowedComment: 'Maximaal %{maxCount} tekens zijn toegestaan',
    switchingBackNote:
      'Terugschakelen naar de klassieke versie van Enlighten Manager? Help ons de nieuwe versie te verbeteren door uw reden om terug te schakelen met ons te delen',
    switchBackTitle: 'Schakel over naar klassieke weergave voor een beperkte tijd',
    new: 'Neu',
    view: 'Anzeigen',
    gridProfileToken: 'Rooster profiel wijziging token',
    ProfileTokenText: 'Profiel wijziging token',
    validText: 'Dit token is één dag geldig voor Envoy %{serialNumber}.',
    envoySerialNumber: 'Envoy Serienummer',
    authorizationNumber: 'Machtigingsnummer',
    getToken: 'Token ophalen',
    viewAll: 'Alle ansehen',
    viewFullList: 'Vollständige Liste anzeigen',
    serviceRequests: 'Servicefälle',
    inProgressRequests: 'In Bearbeitung',
    totalCases: 'Gesamtfälle',
    resolvedRequests: 'Gelöst',
    viewDetails: 'Details Anzeigen'
  }
};

export default dashboard;
